import { useCallback } from "react"
import { Block, useStyletron } from "@mezo-org/mezo-clay"

import { SwapFormValue } from "#/shared/types"

import { ComponentStepProps, useStepperModalContext } from "../StepperModal"

import SwapModalForm from "./SwapModalForm"

export default function SwapModalBase({ onClickContinue }: ComponentStepProps) {
  const [css, theme] = useStyletron()

  const { values, setValues } = useStepperModalContext<SwapFormValue>()

  const handelSubmitForm = useCallback(
    (formValues: SwapFormValue) => {
      setValues(formValues)
      onClickContinue()
    },
    [onClickContinue, setValues],
  )

  return (
    <Block
      className={css({
        padding: `0 ${theme.sizing.scale800} ${theme.sizing.scale800}`,
        height: "100%",
      })}
    >
      <SwapModalForm values={values} onSubmitForm={handelSubmitForm} />
    </Block>
  )
}
